/**
 * Cart CEP Only — Turma Wine / Concept 6.0.2
 *
 * Deixa o cálculo de frete do CARRINHO (página /cart e cart drawer) pedindo
 * SOMENTE o CEP. Os campos "País/região" e "Província" continuam no DOM — o
 * script preenche os dois sozinho — mas somem da tela.
 *
 * Como funciona:
 *   1. Esconde o <country-province> via CSS injetado por JS.
 *   2. Força o país para Brasil.
 *   3. Deriva a UF a partir da faixa de CEP (tabela offline dos Correios) e
 *      seleciona a província correspondente ANTES do tema enviar a requisição.
 *   4. Opcionalmente consulta o ViaCEP só para mostrar "Cidade / UF" embaixo
 *      do campo (não bloqueia o cálculo se a API cair).
 *
 * Não altera nenhum arquivo do tema. Se este script não carregar, o formulário
 * volta ao comportamento original (país + província + CEP visíveis).
 */

(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /* Configuração                                                        */
  /* ------------------------------------------------------------------ */

  var COUNTRY_NAMES = ['Brazil', 'Brasil', 'BR']; // candidatos aceitos no <select>
  var SHOW_CITY = true;      // mostra "São Paulo / SP" embaixo do campo
  var ZIP_LABEL = 'Digite seu CEP';

  /* Faixas de CEP por UF — funciona offline, nunca falha. */
  var CEP_RANGES = [
    [1000000, 19999999, 'SP'],
    [20000000, 28999999, 'RJ'],
    [29000000, 29999999, 'ES'],
    [30000000, 39999999, 'MG'],
    [40000000, 48999999, 'BA'],
    [49000000, 49999999, 'SE'],
    [50000000, 56999999, 'PE'],
    [57000000, 57999999, 'AL'],
    [58000000, 58999999, 'PB'],
    [59000000, 59999999, 'RN'],
    [60000000, 63999999, 'CE'],
    [64000000, 64999999, 'PI'],
    [65000000, 65999999, 'MA'],
    [66000000, 68899999, 'PA'],
    [68900000, 68999999, 'AP'],
    [69000000, 69299999, 'AM'],
    [69300000, 69399999, 'RR'],
    [69400000, 69899999, 'AM'],
    [69900000, 69999999, 'AC'],
    [70000000, 72799999, 'DF'],
    [72800000, 72999999, 'GO'],
    [73000000, 73699999, 'DF'],
    [73700000, 76799999, 'GO'],
    [76800000, 76999999, 'RO'],
    [77000000, 77999999, 'TO'],
    [78000000, 78899999, 'MT'],
    [78900000, 78999999, 'RO'],
    [79000000, 79999999, 'MS'],
    [80000000, 87999999, 'PR'],
    [88000000, 89999999, 'SC'],
    [90000000, 99999999, 'RS']
  ];

  var UF_NAMES = {
    AC: 'Acre', AL: 'Alagoas', AP: 'Amapá', AM: 'Amazonas', BA: 'Bahia',
    CE: 'Ceará', DF: 'Distrito Federal', ES: 'Espírito Santo', GO: 'Goiás',
    MA: 'Maranhão', MT: 'Mato Grosso', MS: 'Mato Grosso do Sul',
    MG: 'Minas Gerais', PA: 'Pará', PB: 'Paraíba', PR: 'Paraná',
    PE: 'Pernambuco', PI: 'Piauí', RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul', RO: 'Rondônia',
    RR: 'Roraima', SC: 'Santa Catarina', SP: 'São Paulo', SE: 'Sergipe',
    TO: 'Tocantins'
  };

  var FORM_SELECTOR = 'form[is="shipping-calculator"]';
  var ZIP_SELECTOR = '[name="address[zip]"]';
  var COUNTRY_SELECTOR = '[name="address[country]"]';
  var PROVINCE_SELECTOR = '[name="address[province]"]';

  var cityCache = {};

  /* ------------------------------------------------------------------ */
  /* Utilidades                                                          */
  /* ------------------------------------------------------------------ */

  function digits(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 8);
  }

  function maskZip(value) {
    var d = digits(value);
    return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
  }

  function ufFromZip(zip) {
    var n = parseInt(zip, 10);
    if (!isFinite(n)) return '';
    for (var i = 0; i < CEP_RANGES.length; i++) {
      if (n >= CEP_RANGES[i][0] && n <= CEP_RANGES[i][1]) return CEP_RANGES[i][2];
    }
    return '';
  }

  /* Compara ignorando acento, caixa e espaços extras. */
  function normalize(value) {
    var text = String(value || '');
    if (text.normalize) text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return text.trim().toLowerCase();
  }

  /**
   * Seleciona no <select> a primeira opção cujo value OU texto bata com um dos
   * candidatos. Devolve true se conseguiu.
   */
  function selectByCandidates(select, candidates) {
    if (!select) return false;
    var wanted = candidates.map(normalize);
    for (var i = 0; i < select.options.length; i++) {
      var option = select.options[i];
      if (wanted.indexOf(normalize(option.value)) !== -1 ||
          wanted.indexOf(normalize(option.textContent)) !== -1) {
        if (select.selectedIndex !== i) select.selectedIndex = i;
        return true;
      }
    }
    return false;
  }

  function fire(element, type) {
    if (!element) return;
    element.dispatchEvent(new Event(type, { bubbles: true }));
  }

  /* ------------------------------------------------------------------ */
  /* CSS — injetado por JS de propósito                                  */
  /* ------------------------------------------------------------------ */

  function injectStyles() {
    if (document.getElementById('cart-cep-only-styles')) return;
    var style = document.createElement('style');
    style.id = 'cart-cep-only-styles';
    style.textContent =
      FORM_SELECTOR + ' country-province{display:none !important;}' +
      FORM_SELECTOR + ' .cep-only-hint{margin-top:.5rem;font-size:.8125rem;line-height:1.3;opacity:.7;}' +
      FORM_SELECTOR + ' .input.invalid{border-color:rgb(var(--color-error, 220 38 38));}';
    document.head.appendChild(style);
  }

  /* ------------------------------------------------------------------ */
  /* Sincronização país + província                                      */
  /* ------------------------------------------------------------------ */

  /**
   * Garante país = Brasil e província = UF do CEP digitado.
   * Roda antes de qualquer envio, então o tema sempre manda o endereço completo.
   */
  function syncAddress(form) {
    var zipInput = form.querySelector(ZIP_SELECTOR);
    var countrySelect = form.querySelector(COUNTRY_SELECTOR);
    var provinceSelect = form.querySelector(PROVINCE_SELECTOR);
    if (!zipInput || !countrySelect || !provinceSelect) return '';

    /* País */
    var hadCountry = selectByCandidates(countrySelect, COUNTRY_NAMES);
    if (hadCountry && !provinceSelect.options.length) {
      /* Dispara o <country-province> do tema para popular as províncias. */
      fire(countrySelect, 'change');
    }

    /* Província a partir do CEP */
    var zip = digits(zipInput.value);
    var uf = ufFromZip(zip);
    if (uf) {
      selectByCandidates(provinceSelect, [uf, UF_NAMES[uf]]);
    }

    /* Normaliza o CEP enviado: só dígitos, formato aceito pela Shopify. */
    zipInput.value = maskZip(zip);

    return uf;
  }

  /* ------------------------------------------------------------------ */
  /* Dica de cidade (ViaCEP) — puramente cosmética                       */
  /* ------------------------------------------------------------------ */

  function hintElement(form) {
    var hint = form.querySelector('.cep-only-hint');
    if (hint) return hint;
    var zipInput = form.querySelector(ZIP_SELECTOR);
    if (!zipInput) return null;
    hint = document.createElement('p');
    hint.className = 'cep-only-hint';
    hint.setAttribute('aria-live', 'polite');
    var field = zipInput.closest('.field') || zipInput.parentElement;
    field.parentElement.insertBefore(hint, field.nextSibling);
    return hint;
  }

  function showCity(form, zip, uf) {
    if (!SHOW_CITY) return;
    var hint = hintElement(form);
    if (!hint) return;

    if (zip.length !== 8) { hint.textContent = ''; return; }

    if (cityCache[zip] !== undefined) {
      hint.textContent = cityCache[zip];
      return;
    }

    hint.textContent = uf ? UF_NAMES[uf] : '';

    fetch('https://viacep.com.br/ws/' + zip + '/json/')
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (!data || data.erro || !data.localidade) return;
        var label = data.localidade + ' / ' + data.uf;
        cityCache[zip] = label;
        if (digits(form.querySelector(ZIP_SELECTOR).value) === zip) {
          hint.textContent = label;
        }
      })
      .catch(function () { /* silencioso: o cálculo não depende disso */ });
  }

  /* ------------------------------------------------------------------ */
  /* Preparação visual do formulário                                     */
  /* ------------------------------------------------------------------ */

  function prepare(form) {
    if (form.dataset.cepOnly === 'true') return;
    var zipInput = form.querySelector(ZIP_SELECTOR);
    var countrySelect = form.querySelector(COUNTRY_SELECTOR);
    if (!zipInput || !countrySelect) return;

    form.dataset.cepOnly = 'true';

    zipInput.setAttribute('inputmode', 'numeric');
    zipInput.setAttribute('maxlength', '9');
    zipInput.setAttribute('autocomplete', 'postal-code');
    zipInput.removeAttribute('autocapitalize');

    var label = form.querySelector('label[for="' + zipInput.id + '"]');
    if (label) label.textContent = ZIP_LABEL;

    if (zipInput.value) {
      zipInput.value = maskZip(zipInput.value);
      syncAddress(form);
    }

    /* País precisa ser definido já no carregamento: o <country-province> do
       tema seleciona a primeira opção da lista quando não há cliente logado. */
    setTimeout(function () { syncAddress(form); }, 0);
  }

  function scan(root) {
    var forms = (root || document).querySelectorAll(FORM_SELECTOR);
    for (var i = 0; i < forms.length; i++) prepare(forms[i]);
  }

  /* ------------------------------------------------------------------ */
  /* Delegação de eventos                                                */
  /* ------------------------------------------------------------------ */

  /* Máscara enquanto digita. */
  document.addEventListener('input', function (event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches(ZIP_SELECTOR)) return;
    var form = target.closest(FORM_SELECTOR);
    if (!form) return;

    var masked = maskZip(target.value);
    if (masked !== target.value) target.value = masked;
    target.classList.remove('invalid');

    var zip = digits(masked);
    var uf = ufFromZip(zip);
    if (zip.length === 8) {
      syncAddress(form);
      showCity(form, zip, uf);
    } else {
      showCity(form, zip, uf);
    }
  }, true);

  /**
   * Captura no document: roda ANTES do listener que o tema pendura no botão,
   * então país e província já vão preenchidos na requisição.
   */
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[type="submit"]');
    if (!button) return;
    var form = button.closest(FORM_SELECTOR);
    if (!form) return;

    var zipInput = form.querySelector(ZIP_SELECTOR);
    var zip = digits(zipInput ? zipInput.value : '');

    if (zip.length !== 8) {
      event.preventDefault();
      event.stopPropagation();
      if (zipInput) {
        zipInput.classList.add('invalid');
        zipInput.focus();
      }
      var hint = hintElement(form);
      if (hint) hint.textContent = 'Digite um CEP válido com 8 dígitos.';
      return;
    }

    syncAddress(form);
  }, true);

  /* Enter no campo de CEP calcula, em vez de dar POST na página. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var target = event.target;
    if (!target || !target.matches || !target.matches(ZIP_SELECTOR)) return;
    var form = target.closest(FORM_SELECTOR);
    if (!form) return;

    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button) button.click();
  }, true);

  /* ------------------------------------------------------------------ */
  /* Boot + cart drawer (conteúdo entra no DOM depois)                   */
  /* ------------------------------------------------------------------ */

  function boot() {
    injectStyles();
    scan(document);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(FORM_SELECTOR)) prepare(node);
          else if (node.querySelector && node.querySelector(FORM_SELECTOR)) scan(node);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
